export default "__VITE_ASSET__l02Go$9Q__"